import { Component, OnInit } from "@angular/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatSidenavModule } from "@angular/material/sidenav";
import { Router, RouterModule } from "@angular/router";
import { LocalStorageService } from "../../services/local-storage.service";

@Component({
    selector: "app-site-nav",
    standalone: true,
    imports: [RouterModule, MatSidenavModule, MatIconModule, MatListModule, MatExpansionModule],
    templateUrl: "./site-nav.component.html",
    styleUrls: ["./site-nav.component.scss"],
})
export class SiteNavComponent implements OnInit {
    activeRoute = "";

    readonly PRODUCTS = [
        {
            route: "tts",
            label: "TikTok Shop",
            subProducts: [
                {
                    route: "tts/claims",
                    label: "Service Request",
                    icon: "receipt",
                },
                {
                    route: "tts/declarations",
                    label: "Policy Declaration",
                    icon: "verified",
                },
            ],
        },
    ];

    constructor(
        private router: Router,
        private localStorageService: LocalStorageService,
    ) {}

    ngOnInit(): void {
        this.activeRoute = this.router.url.split("/")?.[1];
    }
}
